import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { Button, Input, SubTitle } from "../../Components/CustomComponents";
import TextEditor from "../../Components/TextEditor/TextEditor";
import { useUpdatePageMutation } from "../../Data/services/pageApi";
import Toast from "../../Hooks/useToast";
import styles from "./styles/StaticPage.module.scss";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";

export default function PrivacyPolicy({ data, isLoading, refetch }) {
  const { handleSubmit, control, register, errors, setValue } = useForm({
    mode: "onChange",
  });
  const [updatePage, { isLoading: isLoadingUpdate }] = useUpdatePageMutation();

  // const [value, setUpdateValue] = useState(
  //   "<h1>Terms and Conditions</h1><h2>What is Lorem Ipsum?</h2><p><br></p><p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p > <p><br></p>"
  // );

  useEffect(() => {
    setValue("url", data?.data?.url);
    setValue("title", data?.data?.title);
    setValue("content", data?.data?.content);
  }, [data, refetch]);

  const onUpdateSubmit = async (data) => {
    try {
      let response = await updatePage({ id: 1, modifiedData: data }).unwrap();
      refetch();
      Toast(response?.message, "success");
    } catch (error) {
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <div className={styles.StaticPage}>
      <Form onSubmit={handleSubmit(onUpdateSubmit)}>
        <Row>
          <Col sm={10}>
            <SubTitle
              text="Privacy Policy"
              classes="mb-4 primary-text text-white"
            />

            <label className="fs-6 fw-bold text-white">URL</label>
            <Controller
              control={control}
              name="url"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Input
                  name="url"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />

            <label className="fs-6 fw-bold text-white">Title</label>
            <Controller
              control={control}
              name="title"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Input
                  name="title"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col sm={2}>
            <Button
              classes={`${styles.cardBtn} `}
              text={isLoading ? <LoadingButton /> : "Save"}
              type="submit"
              disabled={isLoadingUpdate}
            ></Button>
          </Col>
        </Row>
      </Form>

      <label className="fs-6 fw-bold text-white">Content</label>
      <Controller
        control={control}
        name="content"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <TextEditor text={value} onChange={onChange} />
        )}
      />
    </div>
  );
}
